import { Component, OnInit } from '@angular/core';
import { Plate } from '../models/plate';

import { PlateStatusService } from '../plate-status1/plate-status.service';
import { MessagesService } from '../messages/messages.service';
import { SortEvent } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { Action, BeadChipAction } from '../models/action';
import { PlateStatus } from '../models/process-step';

@Component({
  selector: 'app-plate-status1',
  templateUrl: './plate-status1.component.html',
  styleUrls: ['./plate-status1.component.css']
})
export class PlateStatus1Component implements OnInit {

  plates: Plate[];

  loading: boolean;
  platesList:Plate[]=[];

  dataRefresher: any;
  selectedLabId : string ="";


  constructor(private plateStatusService: PlateStatusService,
    private _messagesService: MessagesService,
    public datepipe: DatePipe
  ) { }

  ngOnInit() {
    this.selectedLabId = JSON.parse(localStorage.getItem("lab")).lab._id;
    this.fetchPlateStatuses();
    this.refreshData();
  }

  refreshData(){
    this.dataRefresher =
      setInterval(() => {
        this.fetchPlateStatuses();
      }, 60000);
  }

  cancelPageRefresh(){
    if(this.dataRefresher){
        clearInterval(this.dataRefresher);
    }
  }

  ngOnDestroy(){
    this.cancelPageRefresh();
  }

  calculateRemainingTime(actionRun: number, actionStart: Date) {
    let endTime = this.calculateEndTime(actionRun, actionStart);
    
    let remainingTime = endTime.getTime() - this.getNowUTC().getTime();
    if(remainingTime<=0){
      remainingTime=0;
    }
    return  Math.round(remainingTime / 60000);
  }

  private getNowUTC() {
    const now = new Date();
    return new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
  }

  fetchPlateStatuses() {
    this.loading = true;
    this.plateStatusService.fetchPlates(this.selectedLabId).subscribe(
      (result) => {
        this.loading = false;
        this.platesList = result;
        this.platesList.forEach(plate_ => {
          plate_.endTime = new Date(this.calculateEndTime(plate_.actionRunTime, plate_.actionStartTime).toString() + 'UTC');
          plate_.remainingMinutes = this.calculateRemainingTime(plate_.actionRunTime, plate_.actionStartTime);
        });
      },
      (error) => {
        this.loading = false;
        console.log("Error in fetching received plates ", error);
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plates',
          detail: 'Some issue in pulling the plates info, please try again'
        })
      })
  }



  calculateEndTime(actionRunTime: number, actionStartTime: any) {
    const date_: Date = new Date(actionStartTime);
    date_.setMinutes(date_.getMinutes() + actionRunTime);

    return date_;
  }

  getValue(plateValue: Plate) {
    return 100 - Math.round((plateValue.remainingMinutes / plateValue.actionRunTime) * 100);
  }

  isIndeterminate(plateValue: Plate) {
    if (plateValue.actionStartTime) {
      return 'determinate';
    } else {
      return plateValue.remainingMinutes == 0 ? 'indeterminate' : 'determinate';
    }
  }



  getRunUntil(plateValue: Plate) {
    if (plateValue.actionStartTime) {
      return 'FREE';
    } else {
      if (!plateValue.startTime) {
        return null;
      } else {
        if (plateValue.progressValue < plateValue.remainingMinutes || this.isIndeterminate(plateValue) == 'indeterminate') {
          let progressMins = (plateValue.remainingMinutes ? plateValue.remainingMinutes : 0);
          return this.datepipe.transform(new Date(plateValue.startTime.getTime() + progressMins * 60000), 'HH:mm');
        } else {
          return 'COMPLETE';
        }
      }
    }

  }

  getActionStatus(plateValue: Plate){
    if(plateValue.remainingMinutes == 0)
      return 1;
    else if(plateValue.remainingMinutes>0 && plateValue.remainingMinutes<=60)
      return 2;
    else
      return 3;
  }

  customSort(event: SortEvent) {

    event.data.sort((data1, data2) => {

      let value1,value2;

        if(event.field == 'remainingPercent'){
          value1 = this.getValue(data1);
          value2 = this.getValue(data2);
        }
        else{
          value1 = data1[event.field];
          value2 = data2[event.field];
        }
        let result = null;

        if (value1 == null && value2 != null)
            result = -1;
        else if (value1 != null && value2 == null)
            result = 1;
        else if (value1 == null && value2 == null)
            result = 0;
        else if (typeof value1 === 'string' && typeof value2 === 'string')
            result = value1.localeCompare(value2);
        else
            result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

        return (event.order * result);
    });
  }
  getPlateValue(plate: Plate){
    if(Action.RUN_THERMO_CYCLER == plate.action){
      return plate.pgxPlateID;
    }
    else if(PlateStatus.PGX_COMPLETED == plate.status){
      return plate.wgaPlateID;
    }
    else{
      return plate.lastUpdatedPlateID;
    }

  }
}
